(ns superadmin.os-workspace-editor.create-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [re-frame.core :as rf]
            [superadmin.os-workspace-editor.create-ocp.db :as form]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer []
  (let [errors (use-subscribe [:form.os-workspace-editor.create/errors?])]
    ($ Button
       {:type "submit"
        :variant "contained"
        :disabled errors
        :data-testid "mapping-submit"}
       "Create Mapping")))

(defocp create-ocp :os-workspace-mapping/create {:width 600} [_]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.os-workspace-editor.create/init-form])
                    (fn []
                      (rf/dispatch [:form.os-workspace-editor.create/destroy])))
                  [])
  ($ ocp
     {:title "Create Mapping"
      :footer ($ ocp-footer)
      :on-submit #(rf/dispatch [:form.os-workspace-editor.create/submit])}
     ($ form-field
        {:label "Workspace ID"
         :err-msg (form/use-error-message [:workspace-id])}
        ($ input
           (merge (form/use-bind-control [:workspace-id])
                  {:type "text"
                   :data-testid "workspace-id-input"})))
     ($ form-field
        {:label "Agency id"
         :err-msg (form/use-error-message [:agency-id])}
        ($ input
           (merge (form/use-bind-control [:agency-id])
                  {:type "text"
                   :data-testid "agency-id-input"})))
     ($ form-field
        {:label "Advertiser id"
         :err-msg (form/use-error-message [:advertiser-id])}
        ($ input
           (merge (form/use-bind-control [:advertiser-id])
                  {:type "text"
                   :data-testid "advertiser-id-input"})))
     ($ form-field
        {:label "Requester email"
         :err-msg (form/use-error-message [:email])}

        ($ input
           (merge (form/use-bind-control [:email])
                  {:type "text"
                   :data-testid "email-input"}))
        ($ checkbox
           (merge (form/use-bind-control [:notify-user])
                  {:disabled? (not (use-subscribe [:form.os-workspace-editor.create/email-is-not-empty-and-valid]))
                   :label "Notify user"})))
     ($ form-field
        {:label "Comment"
         :err-msg (form/use-error-message [:comment])}
        ($ input
           (merge (form/use-bind-control [:comment])
                  {:type "text"
                   :data-testid "comment-id-input"})))))
